module.exports = "/_next/static/images/8fa777829f873a8f155608f9ce9a843c-nubanker-bizarch@1x.jpg.webp";